import "./InteriorImg.css";
import { useHrStyles } from "../../Context/HRContext";
import { Button } from "react-bootstrap";

export default function InteriorImg() {
  const hrStyles = useHrStyles();

  return (
    <div className="interior-img-content">
      <h1 className="Int-heading">Interior Architecture</h1>
      <p className="Int-text">
        At BEAMS, we believe the interior of a space should tell a story. Our
        interior architecture services focus on creating custom designs that
        blend style and functionality. From open-plan living areas to intimate,
        personalized spaces, we design interiors that reflect your lifestyle,
        promote well-being, and maximize space utilization. Every detail, from
        furniture selection to lighting design, is meticulously crafted to
        create an environment that feels both inspiring and comfortable.
      </p>
      <Button
        href="/Contact"
        variant="danger"
        size="lg"
        className="centered-button"
      >
        Contact Us
      </Button>
      <hr style={hrStyles} />
    </div>
  );
}
